import React from 'react';
import { Row, Col } from '../../../../grid';
import { Paragraph } from '../../../../typography';
import { SalesPrice } from '../../../parts';

const RenderDiscount = ({
  discount,
  beforePrice,
}) => {
  if (discount && discount > 0) {
    return (
      <Row>
        <Col xs={12}>
          <Paragraph>
            <SalesPrice beforePrice={beforePrice} discount={discount} />
          </Paragraph>
        </Col>
      </Row>
    );
  }
  return (null);
};

// Export
export default RenderDiscount;
